import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    addressline1: {
      validations: [
        { type: 'required', message: 'Please provide address of event' }
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please provide a city' }
      ]
    },
    bustype: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email address' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide primary contact phone #' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    cellnumber: {
      validations: [
        { type: 'required', message: 'Please provide primary contact cell phone #' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid cell phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    notes: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide the number of people in your party' }
      ]
    },
    starttime: {
      validations: [
          { type: 'required', message: 'Please select a serving time' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: '*First Name:',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: '*Last Name:',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: '*Address of Event:',
            mapping: 'addressline1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: '*Event City:',
            options: [
              { label: 'Alachua' , value: 'Alachua'},
              { label: 'Alford' , value: 'Alford'},
              { label: 'Altamonte Springs' , value: 'Altamonte Springs'},
              { label: 'Altha' , value: 'Altha'},
              { label: 'Altoona' , value: 'Altoona'},
              { label: 'Alturas' , value: 'Alturas'},
              { label: 'Alva' , value: 'Alva'},
              { label: 'Anna Maria' , value: 'Anna Maria'},
              { label: 'Anthony' , value: 'Anthony'},
              { label: 'Apalachicola' , value: 'Apalachicola'},
              { label: 'Apollo Beach' , value: 'Apollo Beach'},
              { label: 'Apopka' , value: 'Apopka'},
              { label: 'Arcadia' , value: 'Arcadia'},
              { label: 'Archer' , value: 'Archer'},
              { label: 'Argyle' , value: 'Argyle'},
              { label: 'Aripeka' , value: 'Aripeka'},
              { label: 'Astatula' , value: 'Astatula'},
              { label: 'Astor' , value: 'Astor'},
              { label: 'Atlantic Beach' , value: 'Atlantic Beach'},
              { label: 'Auburndale' , value: 'Auburndale'},
              { label: 'Avon Park' , value: 'Avon Park'},
              { label: 'Babson Park' , value: 'Babson Park'},
              { label: 'Bagdad' , value: 'Bagdad'},
              { label: 'Baker' , value: 'Baker'},
              { label: 'Balm' , value: 'Balm'},
              { label: 'Barberville' , value: 'Barberville'},
              { label: 'Bartow' , value: 'Bartow'},
              { label: 'Bascom' , value: 'Bascom'},
              { label: 'Bay Pines' , value: 'Bay Pines'},
              { label: 'Bell' , value: 'Bell'},
              { label: 'Belle Glade' , value: 'Belle Glade'},
              { label: 'Belleair Beach' , value: 'Belleair Beach'},
              { label: 'Belleview' , value: 'Belleview'},
              { label: 'Beverly Hills' , value: 'Beverly Hills'},
              { label: 'Big Pine Key' , value: 'Big Pine Key'},
              { label: 'Blountstown' , value: 'Blountstown'},
              { label: 'Boca Grande' , value: 'Boca Grande'},
              { label: 'Boca Raton' , value: 'Boca Raton'},
              { label: 'Bokeelia' , value: 'Bokeelia'},
              { label: 'Bonifay' , value: 'Bonifay'},
              { label: 'Bonita Springs' , value: 'Bonita Springs'},
              { label: 'Bostwick' , value: 'Bostwick'},
              { label: 'Bowling Green' , value: 'Bowling Green'},
              { label: 'Boynton Beach' , value: 'Boynton Beach'},
              { label: 'Bradenton' , value: 'Bradenton'},
              { label: 'Bradenton Beach' , value: 'Bradenton Beach'},
              { label: 'Bradley' , value: 'Bradley'},
              { label: 'Brandon' , value: 'Brandon'},
              { label: 'Branford' , value: 'Branford'},
              { label: 'Bristol' , value: 'Bristol'},
              { label: 'Bronson' , value: 'Bronson'},
              { label: 'Brooker' , value: 'Brooker'},
              { label: 'Brooksville' , value: 'Brooksville'},
              { label: 'Bryceville' , value: 'Bryceville'},
              { label: 'Bunnell' , value: 'Bunnell'},
              { label: 'Bushnell' , value: 'Bushnell'},
              { label: 'Callahan' , value: 'Callahan'},
              { label: 'Campbellton' , value: 'Campbellton'},
              { label: 'Canal Point' , value: 'Canal Point'},
              { label: 'Candler' , value: 'Candler'},
              { label: 'Cantonment' , value: 'Cantonment'},
              { label: 'Cape Canaveral' , value: 'Cape Canaveral'},
              { label: 'Cape Coral' , value: 'Cape Coral'},
              { label: 'Captiva' , value: 'Captiva'},
              { label: 'Carrabelle' , value: 'Carrabelle'},
              { label: 'Caryville' , value: 'Caryville'},
              { label: 'Cassadaga' , value: 'Cassadaga'},
              { label: 'Casselberry' , value: 'Casselberry'},
              { label: 'Cedar Key' , value: 'Cedar Key'},
              { label: 'Center Hill' , value: 'Center Hill'},
              { label: 'Century' , value: 'Century'},
              { label: 'Chattahoochee' , value: 'Chattahoochee'},
              { label: 'Chiefland' , value: 'Chiefland'},
              { label: 'Chipley' , value: 'Chipley'},
              { label: 'Chokoloskee' , value: 'Chokoloskee'},
              { label: 'Christmas' , value: 'Christmas'},
              { label: 'Citra' , value: 'Citra'},
              { label: 'Clarcona' , value: 'Clarcona'},
              { label: 'Clarksville' , value: 'Clarksville'},
              { label: 'Clearwater' , value: 'Clearwater'},
              { label: 'Clearwater Beach' , value: 'Clearwater Beach'},
              { label: 'Clermont' , value: 'Clermont'},
              { label: 'Clewiston' , value: 'Clewiston'},
              { label: 'Cocoa' , value: 'Cocoa'},
              { label: 'Cocoa Beach' , value: 'Cocoa Beach'},
              { label: 'Coconut Creek' , value: 'Coconut Creek'},
              { label: 'Coleman' , value: 'Coleman'},
              { label: 'Copeland' , value: 'Copeland'},
              { label: 'Coral Gables' , value: 'Coral Gables'},
              { label: 'Coral Springs' , value: 'Coral Springs'},
              { label: 'Cortez' , value: 'Cortez'},
              { label: 'Cottondale' , value: 'Cottondale'},
              { label: 'Crawfordville' , value: 'Crawfordville'},
              { label: 'Crescent City' , value: 'Crescent City'},
              { label: 'Crestview' , value: 'Crestview'},
              { label: 'Cross City' , value: 'Cross City'},
              { label: 'Crystal Beach' , value: 'Crystal Beach'},
              { label: 'Crystal River' , value: 'Crystal River'},
              { label: 'Crystal Springs' , value: 'Crystal Springs'},
              { label: 'Cypress' , value: 'Cypress'},
              { label: 'Dade City' , value: 'Dade City'},
              { label: 'Dania' , value: 'Dania'},
              { label: 'Davenport' , value: 'Davenport'},
              { label: 'Day' , value: 'Day'},
              { label: 'Daytona Beach' , value: 'Daytona Beach'},
              { label: 'De Leon Springs' , value: 'De Leon Springs'},
              { label: 'Debary' , value: 'Debary'},
              { label: 'Deerfield Beach' , value: 'Deerfield Beach'},
              { label: 'Defuniak Springs' , value: 'Defuniak Springs'},
              { label: 'Deland' , value: 'Deland'},
              { label: 'Delray Beach' , value: 'Delray Beach'},
              { label: 'Deltona' , value: 'Deltona'},
              { label: 'Destin' , value: 'Destin'},
              { label: 'Doctors Inlet' , value: 'Doctors Inlet'},
              { label: 'Dover' , value: 'Dover'},
              { label: 'Dundee' , value: 'Dundee'},
              { label: 'Dunedin' , value: 'Dunedin'},
              { label: 'Dunnellon' , value: 'Dunnellon'},
              { label: 'Durant' , value: 'Durant'},
              { label: 'Eagle Lake' , value: 'Eagle Lake'},
              { label: 'Earleton' , value: 'Earleton'},
              { label: 'East Palatka' , value: 'East Palatka'},
              { label: 'Eastlake Weir' , value: 'Eastlake Weir'},
              { label: 'Eastpoint' , value: 'Eastpoint'},
              { label: 'Eaton Park' , value: 'Eaton Park'},
              { label: 'Ebro' , value: 'Ebro'},
              { label: 'Edgar' , value: 'Edgar'},
              { label: 'Edgewater' , value: 'Edgewater'},
              { label: 'Eglin Afb' , value: 'Eglin Afb'},
              { label: 'El Jobean' , value: 'El Jobean'},
              { label: 'Elfers' , value: 'Elfers'},
              { label: 'Elkton' , value: 'Elkton'},
              { label: 'Ellenton' , value: 'Ellenton'},
              { label: 'Englewood' , value: 'Englewood'},
              { label: 'Estero' , value: 'Estero'},
              { label: 'Eustis' , value: 'Eustis'},
              { label: 'Everglades City' , value: 'Everglades City'},
              { label: 'Evinston' , value: 'Evinston'},
              { label: 'Fairfield' , value: 'Fairfield'},
              { label: 'Felda' , value: 'Felda'},
              { label: 'Fellsmere' , value: 'Fellsmere'},
              { label: 'Fernandina Beach' , value: 'Fernandina Beach'},
              { label: 'Ferndale' , value: 'Ferndale'},
              { label: 'Flagler Beach' , value: 'Flagler Beach'},
              { label: 'Fleming Island' , value: 'Fleming Island'},
              { label: 'Florahome' , value: 'Florahome'},
              { label: 'Floral City' , value: 'Floral City'},
              { label: 'Fort Lauderdale' , value: 'Fort Lauderdale'},
              { label: 'Fort Mc Coy' , value: 'Fort Mc Coy'},
              { label: 'Fort Meade' , value: 'Fort Meade'},
              { label: 'Fort Myers' , value: 'Fort Myers'},
              { label: 'Fort Myers Beach' , value: 'Fort Myers Beach'},
              { label: 'Fort Ogden' , value: 'Fort Ogden'},
              { label: 'Fort Pierce' , value: 'Fort Pierce'},
              { label: 'Fort Walton Beach' , value: 'Fort Walton Beach'},
              { label: 'Fort White' , value: 'Fort White'},
              { label: 'Fountain' , value: 'Fountain'},
              { label: 'Freeport' , value: 'Freeport'},
              { label: 'Frostproof' , value: 'Frostproof'},
              { label: 'Fruitland Park' , value: 'Fruitland Park'},
              { label: 'Gainesville' , value: 'Gainesville'},
              { label: 'Geneva' , value: 'Geneva'},
              { label: 'Georgetown' , value: 'Georgetown'},
              { label: 'Gibsonton' , value: 'Gibsonton'},
              { label: 'Glen Saint Mary' , value: 'Glen Saint Mary'},
              { label: 'Glenwood' , value: 'Glenwood'},
              { label: 'Goldenrod' , value: 'Goldenrod'},
              { label: 'Gonzalez' , value: 'Gonzalez'},
              { label: 'Goodland' , value: 'Goodland'},
              { label: 'Gotha' , value: 'Gotha'},
              { label: 'Graceville' , value: 'Graceville'},
              { label: 'Graham' , value: 'Graham'},
              { label: 'Grand Island' , value: 'Grand Island'},
              { label: 'Grand Ridge' , value: 'Grand Ridge'},
              { label: 'Grandin' , value: 'Grandin'},
              { label: 'Grant' , value: 'Grant'},
              { label: 'Green Cove Springs' , value: 'Green Cove Springs'},
              { label: 'Greenacres' , value: 'Greenacres'},
              { label: 'Greensboro' , value: 'Greensboro'},
              { label: 'Greenville' , value: 'Greenville'},
              { label: 'Greenwood' , value: 'Greenwood'},
              { label: 'Gretna' , value: 'Gretna'},
              { label: 'Groveland' , value: 'Groveland'},
              { label: 'Gulf Breeze' , value: 'Gulf Breeze'},
              { label: 'Gulf Hammock' , value: 'Gulf Hammock'},
              { label: 'Haines City' , value: 'Haines City'},
              { label: 'Hallandale' , value: 'Hallandale'},
              { label: 'Hampton' , value: 'Hampton'},
              { label: 'Hastings' , value: 'Hastings'},
              { label: 'Havana' , value: 'Havana'},
              { label: 'Hawthorne' , value: 'Hawthorne'},
              { label: 'Hernando' , value: 'Hernando'},
              { label: 'Hialeah' , value: 'Hialeah'},
              { label: 'High Springs' , value: 'High Springs'},
              { label: 'Highland City' , value: 'Highland City'},
              { label: 'Hilliard' , value: 'Hilliard'},
              { label: 'Hobe Sound' , value: 'Hobe Sound'},
              { label: 'Holder' , value: 'Holder'},
              { label: 'Holiday' , value: 'Holiday'},
              { label: 'Hollister' , value: 'Hollister'},
              { label: 'Hollywood' , value: 'Hollywood'},
              { label: 'Holmes Beach' , value: 'Holmes Beach'},
              { label: 'Holt' , value: 'Holt'},
              { label: 'Homeland' , value: 'Homeland'},
              { label: 'Homestead' , value: 'Homestead'},
              { label: 'Homosassa' , value: 'Homosassa'},
              { label: 'Homosassa Springs' , value: 'Homosassa Springs'},
              { label: 'Horseshoe Beach' , value: 'Horseshoe Beach'},
              { label: 'Hosford' , value: 'Hosford'},
              { label: 'Howey In The Hills' , value: 'Howey In The Hills'},
              { label: 'Hudson' , value: 'Hudson'},
              { label: 'Hurlburt Field' , value: 'Hurlburt Field'},
              { label: 'Immokalee' , value: 'Immokalee'},
              { label: 'Indialantic' , value: 'Indialantic'},
              { label: 'Indian Lake Estates' , value: 'Indian Lake Estates'},
              { label: 'Indian Rocks Beach' , value: 'Indian Rocks Beach'},
              { label: 'Indiantown' , value: 'Indiantown'},
              { label: 'Inglis' , value: 'Inglis'},
              { label: 'Intercession City' , value: 'Intercession City'},
              { label: 'Interlachen' , value: 'Interlachen'},
              { label: 'Inverness' , value: 'Inverness'},
              { label: 'Islamorada' , value: 'Islamorada'},
              { label: 'Island Grove' , value: 'Island Grove'},
              { label: 'Istachatta' , value: 'Istachatta'},
              { label: 'Jacksonville' , value: 'Jacksonville'},
              { label: 'Jacksonville Beach' , value: 'Jacksonville Beach'},
              { label: 'Jasper' , value: 'Jasper'},
              { label: 'Jay' , value: 'Jay'},
              { label: 'Jennings' , value: 'Jennings'},
              { label: 'Jensen Beach' , value: 'Jensen Beach'},
              { label: 'Jupiter' , value: 'Jupiter'},
              { label: 'Kathleen' , value: 'Kathleen'},
              { label: 'Kenansville' , value: 'Kenansville'},
              { label: 'Key Biscayne' , value: 'Key Biscayne'},
              { label: 'Key Colony Beach' , value: 'Key Colony Beach'},
              { label: 'Key Largo' , value: 'Key Largo'},
              { label: 'Key West' , value: 'Key West'},
              { label: 'Keystone Heights' , value: 'Keystone Heights'},
              { label: 'Killarney' , value: 'Killarney'},
              { label: 'Kissimmee' , value: 'Kissimmee'},
              { label: 'La Crosse' , value: 'La Crosse'},
              { label: 'labelle' , value: 'labelle'},
              { label: 'Lacoochee' , value: 'Lacoochee'},
              { label: 'Lady Lake' , value: 'Lady Lake'},
              { label: 'Lake Alfred' , value: 'Lake Alfred'},
              { label: 'Lake Butler' , value: 'Lake Butler'},
              { label: 'Lake City' , value: 'Lake City'},
              { label: 'Lake Como' , value: 'Lake Como'},
              { label: 'Lake Geneva' , value: 'Lake Geneva'},
              { label: 'Lake Hamilton' , value: 'Lake Hamilton'},
              { label: 'Lake Harbor' , value: 'Lake Harbor'},
              { label: 'Lake Helen' , value: 'Lake Helen'},
              { label: 'Lake Mary' , value: 'Lake Mary'},
              { label: 'Lake Monroe' , value: 'Lake Monroe'},
              { label: 'Lake Panasoffkee' , value: 'Lake Panasoffkee'},
              { label: 'Lake Placid' , value: 'Lake Placid'},
              { label: 'Lake Wales' , value: 'Lake Wales'},
              { label: 'Lake Worth' , value: 'Lake Worth'},
              { label: 'Lakeland' , value: 'Lakeland'},
              { label: 'Lakeshore' , value: 'Lakeshore'},
              { label: 'Lamont' , value: 'Lamont'},
              { label: 'Lanark Village' , value: 'Lanark Village'},
              { label: 'Land O Lakes' , value: 'Land O Lakes'},
              { label: 'Largo' , value: 'Largo'},
              { label: 'Laurel' , value: 'Laurel'},
              { label: 'Laurel Hill' , value: 'Laurel Hill'},
              { label: 'Lawtey' , value: 'Lawtey'},
              { label: 'Lecanto' , value: 'Lecanto'},
              { label: 'Lee' , value: 'Lee'},
              { label: 'Leesburg' , value: 'Leesburg'},
              { label: 'Lehigh Acres' , value: 'Lehigh Acres'},
              { label: 'Lighthouse Point' , value: 'Lighthouse Point'},
              { label: 'Lithia' , value: 'Lithia'},
              { label: 'Live Oak' , value: 'Live Oak'},
              { label: 'Lloyd' , value: 'Lloyd'},
              { label: 'Lochloosa' , value: 'Lochloosa'},
              { label: 'Long Key' , value: 'Long Key'},
              { label: 'Longboat Key' , value: 'Longboat Key'},
              { label: 'Longwood' , value: 'Longwood'},
              { label: 'Lorida' , value: 'Lorida'},
              { label: 'Loughman' , value: 'Loughman'},
              { label: 'Lowell' , value: 'Lowell'},
              { label: 'Loxahatchee' , value: 'Loxahatchee'},
              { label: 'Lulu' , value: 'Lulu'},
              { label: 'Lutz' , value: 'Lutz'},
              { label: 'Lynn Haven' , value: 'Lynn Haven'},
              { label: 'Macclenny' , value: 'Macclenny'},
              { label: 'Madison' , value: 'Madison'},
              { label: 'Maitland' , value: 'Maitland'},
              { label: 'Malabar' , value: 'Malabar'},
              { label: 'Malone' , value: 'Malone'},
              { label: 'Mango' , value: 'Mango'},
              { label: 'Marathon' , value: 'Marathon'},
              { label: 'Marathon Shores' , value: 'Marathon Shores'},
              { label: 'Marco Island' , value: 'Marco Island'},
              { label: 'Margate' , value: 'Margate'},
              { label: 'Marianna' , value: 'Marianna'},
              { label: 'Mary Esther' , value: 'Mary Esther'},
              { label: 'Mascotte' , value: 'Mascotte'},
              { label: 'Mayo' , value: 'Mayo'},
              { label: 'Mc Alpin' , value: 'Mc Alpin'},
              { label: 'Mc David' , value: 'Mc David'},
              { label: 'Mc Intosh' , value: 'Mc Intosh'},
              { label: 'Melbourne' , value: 'Melbourne'},
              { label: 'Melbourne Beach' , value: 'Melbourne Beach'},
              { label: 'Melrose' , value: 'Melrose'},
              { label: 'Merritt Island' , value: 'Merritt Island'},
              { label: 'Mexico Beach' , value: 'Mexico Beach'},
              { label: 'Miami' , value: 'Miami'},
              { label: 'Miami Beach' , value: 'Miami Beach'},
              { label: 'Miami Gardens' , value: 'Miami Gardens'},
              { label: 'Micanopy' , value: 'Micanopy'},
              { label: 'Mid Florida' , value: 'Mid Florida'},
              { label: 'Middleburg' , value: 'Middleburg'},
              { label: 'Midway' , value: 'Midway'},
              { label: 'Milligan' , value: 'Milligan'},
              { label: 'Milton' , value: 'Milton'},
              { label: 'Mims' , value: 'Mims'},
              { label: 'Minneola' , value: 'Minneola'},
              { label: 'Miramar Beach' , value: 'Miramar Beach'},
              { label: 'Molino' , value: 'Molino'},
              { label: 'Monticello' , value: 'Monticello'},
              { label: 'Montverde' , value: 'Montverde'},
              { label: 'Moore Haven' , value: 'Moore Haven'},
              { label: 'Morriston' , value: 'Morriston'},
              { label: 'Mossy Head' , value: 'Mossy Head'},
              { label: 'Mount Dora' , value: 'Mount Dora'},
              { label: 'Mulberry' , value: 'Mulberry'},
              { label: 'Murdock' , value: 'Murdock'},
              { label: 'Myakka City' , value: 'Myakka City'},
              { label: 'Nalcrest' , value: 'Nalcrest'},
              { label: 'Naples' , value: 'Naples'},
              { label: 'Navarre' , value: 'Navarre'},
              { label: 'Neptune Beach' , value: 'Neptune Beach'},
              { label: 'New Port Richey' , value: 'New Port Richey'},
              { label: 'New Smyrna Beach' , value: 'New Smyrna Beach'},
              { label: 'Newberry' , value: 'Newberry'},
              { label: 'Niceville' , value: 'Niceville'},
              { label: 'Nichols' , value: 'Nichols'},
              { label: 'Nobleton' , value: 'Nobleton'},
              { label: 'Nocatee' , value: 'Nocatee'},
              { label: 'Nokomis' , value: 'Nokomis'},
              { label: 'Noma' , value: 'Noma'},
              { label: 'North Fort Myers' , value: 'North Fort Myers'},
              { label: 'North Miami Beach' , value: 'North Miami Beach'},
              { label: 'North Palm Beach' , value: 'North Palm Beach'},
              { label: 'North Port' , value: 'North Port'},
              { label: 'O Brien' , value: 'O Brien'},
              { label: 'Oak Hill' , value: 'Oak Hill'},
              { label: 'Oakland' , value: 'Oakland'},
              { label: 'Ocala' , value: 'Ocala'},
              { label: 'Ochopee' , value: 'Ochopee'},
              { label: 'Ocklawaha' , value: 'Ocklawaha'},
              { label: 'Ocoee' , value: 'Ocoee'},
              { label: 'Odessa' , value: 'Odessa'},
              { label: 'Okahumpka' , value: 'Okahumpka'},
              { label: 'Okeechobee' , value: 'Okeechobee'},
              { label: 'Old Town' , value: 'Old Town'},
              { label: 'Oldsmar' , value: 'Oldsmar'},
              { label: 'Olustee' , value: 'Olustee'},
              { label: 'Ona' , value: 'Ona'},
              { label: 'Oneco' , value: 'Oneco'},
              { label: 'Opa Locka' , value: 'Opa Locka'},
              { label: 'Orange City' , value: 'Orange City'},
              { label: 'Orange Lake' , value: 'Orange Lake'},
              { label: 'Orange Park' , value: 'Orange Park'},
              { label: 'Orange Springs' , value: 'Orange Springs'},
              { label: 'Orlando' , value: 'Orlando'},
              { label: 'Ormond Beach' , value: 'Ormond Beach'},
              { label: 'Osprey' , value: 'Osprey'},
              { label: 'Osteen' , value: 'Osteen'},
              { label: 'Otter Creek' , value: 'Otter Creek'},
              { label: 'Oviedo' , value: 'Oviedo'},
              { label: 'Oxford' , value: 'Oxford'},
              { label: 'Ozona' , value: 'Ozona'},
              { label: 'Pahokee' , value: 'Pahokee'},
              { label: 'Paisley' , value: 'Paisley'},
              { label: 'Palatka' , value: 'Palatka'},
              { label: 'Palm Bay' , value: 'Palm Bay'},
              { label: 'Palm Beach' , value: 'Palm Beach'},
              { label: 'Palm Beach Gardens' , value: 'Palm Beach Gardens'},
              { label: 'Palm City' , value: 'Palm City'},
              { label: 'Palm Coast' , value: 'Palm Coast'},
              { label: 'Palm Harbor' , value: 'Palm Harbor'},
              { label: 'Palmdale' , value: 'Palmdale'},
              { label: 'Palmetto' , value: 'Palmetto'},
              { label: 'Panacea' , value: 'Panacea'},
              { label: 'Panama City' , value: 'Panama City'},
              { label: 'Panama City Beach' , value: 'Panama City Beach'},
              { label: 'Parrish' , value: 'Parrish'},
              { label: 'Patrick Afb' , value: 'Patrick Afb'},
              { label: 'Paxton' , value: 'Paxton'},
              { label: 'Pembroke Pines' , value: 'Pembroke Pines'},
              { label: 'Penney Farms' , value: 'Penney Farms'},
              { label: 'Pensacola' , value: 'Pensacola'},
              { label: 'Perry' , value: 'Perry'},
              { label: 'Pierson' , value: 'Pierson'},
              { label: 'Pineland' , value: 'Pineland'},
              { label: 'Pinellas Park' , value: 'Pinellas Park'},
              { label: 'Pinetta' , value: 'Pinetta'},
              { label: 'Placida' , value: 'Placida'},
              { label: 'Plant City' , value: 'Plant City'},
              { label: 'Plantation' , value: 'Plantation'},
              { label: 'Plymouth' , value: 'Plymouth'},
              { label: 'Polk City' , value: 'Polk City'},
              { label: 'Pomona Park' , value: 'Pomona Park'},
              { label: 'Pompano Beach' , value: 'Pompano Beach'},
              { label: 'Ponce De Leon' , value: 'Ponce De Leon'},
              { label: 'Ponte Vedra' , value: 'Ponte Vedra'},
              { label: 'Ponte Vedra Beach' , value: 'Ponte Vedra Beach'},
              { label: 'Port Charlotte' , value: 'Port Charlotte'},
              { label: 'Port Orange' , value: 'Port Orange'},
              { label: 'Port Richey' , value: 'Port Richey'},
              { label: 'Port Saint Joe' , value: 'Port Saint Joe'},
              { label: 'Port Saint Lucie' , value: 'Port Saint Lucie'},
              { label: 'Port Salerno' , value: 'Port Salerno'},
              { label: 'Punta Gorda' , value: 'Punta Gorda'},
              { label: 'Putnam Hall' , value: 'Putnam Hall'},
              { label: 'Quincy' , value: 'Quincy'},
              { label: 'Raiford' , value: 'Raiford'},
              { label: 'Reddick' , value: 'Reddick'},
              { label: 'River Ranch' , value: 'River Ranch'},
              { label: 'Riverview' , value: 'Riverview'},
              { label: 'Rockledge' , value: 'Rockledge'},
              { label: 'Roseland' , value: 'Roseland'},
              { label: 'Rosemary Beach' , value: 'Rosemary Beach'},
              { label: 'Rotonda West' , value: 'Rotonda West'},
              { label: 'Royal Palm Beach' , value: 'Royal Palm Beach'},
              { label: 'Ruskin' , value: 'Ruskin'},
              { label: 'Safety Harbor' , value: 'Safety Harbor'},
              { label: 'Saint Augustine' , value: 'Saint Augustine'},
              { label: 'Saint Cloud' , value: 'Saint Cloud'},
              { label: 'Saint James City' , value: 'Saint James City'},
              { label: 'Saint Johns' , value: 'Saint Johns'},
              { label: 'Saint Leo' , value: 'Saint Leo'},
              { label: 'Saint Marks' , value: 'Saint Marks'},
              { label: 'Saint Petersburg' , value: 'Saint Petersburg'},
              { label: 'Salem' , value: 'Salem'},
              { label: 'San Antonio' , value: 'San Antonio'},
              { label: 'San Mateo' , value: 'San Mateo'},
              { label: 'Sanderson' , value: 'Sanderson'},
              { label: 'Sanford' , value: 'Sanford'},
              { label: 'Sanibel' , value: 'Sanibel'},
              { label: 'Santa Rosa Beach' , value: 'Santa Rosa Beach'},
              { label: 'Sarasota' , value: 'Sarasota'},
              { label: 'Satellite Beach' , value: 'Satellite Beach'},
              { label: 'Satsuma' , value: 'Satsuma'},
              { label: 'Scottsmoor' , value: 'Scottsmoor'},
              { label: 'Sebastian' , value: 'Sebastian'},
              { label: 'Sebring' , value: 'Sebring'},
              { label: 'Seffner' , value: 'Seffner'},
              { label: 'Seminole' , value: 'Seminole'},
              { label: 'Seville' , value: 'Seville'},
              { label: 'Shady Grove' , value: 'Shady Grove'},
              { label: 'Shalimar' , value: 'Shalimar'},
              { label: 'Sharpes' , value: 'Sharpes'},
              { label: 'Silver Springs' , value: 'Silver Springs'},
              { label: 'Sneads' , value: 'Sneads'},
              { label: 'Sopchoppy' , value: 'Sopchoppy'},
              { label: 'Sorrento' , value: 'Sorrento'},
              { label: 'South Bay' , value: 'South Bay'},
              { label: 'Sparr' , value: 'Sparr'},
              { label: 'Spring Hill' , value: 'Spring Hill'},
              { label: 'Starke' , value: 'Starke'},
              { label: 'Steinhatchee' , value: 'Steinhatchee'},
              { label: 'Stuart' , value: 'Stuart'},
              { label: 'Sumatra' , value: 'Sumatra'},
              { label: 'Summerfield' , value: 'Summerfield'},
              { label: 'Summerland Key' , value: 'Summerland Key'},
              { label: 'Sumterville' , value: 'Sumterville'},
              { label: 'Sun City' , value: 'Sun City'},
              { label: 'Sun City Center' , value: 'Sun City Center'},
              { label: 'Suwannee' , value: 'Suwannee'},
              { label: 'Sydney' , value: 'Sydney'},
              { label: 'Tallahassee' , value: 'Tallahassee'},
              { label: 'Tallevast' , value: 'Tallevast'},
              { label: 'Tampa' , value: 'Tampa'},
              { label: 'Tangerine' , value: 'Tangerine'}, 
              { label: 'Tarpon Springs' , value: 'Tarpon Springs'},
              { label: 'Tavares' , value: 'Tavares'},
              { label: 'Tavernier' , value: 'Tavernier'},
              { label: 'Telogia' , value: 'Telogia'},
              { label: 'Terra Ceia' , value: 'Terra Ceia'},
              { label: 'The Villages' , value: 'The Villages'},
              { label: 'Thonotosassa' , value: 'Thonotosassa'},
              { label: 'Titusville' , value: 'Titusville'},
              { label: 'Trenton' , value: 'Trenton'},
              { label: 'Trilby' , value: 'Trilby'},
              { label: 'Umatilla' , value: 'Umatilla'},
              { label: 'Valparaiso' , value: 'Valparaiso'},
              { label: 'Valrico' , value: 'Valrico'},
              { label: 'Venice' , value: 'Venice'},
              { label: 'Venus' , value: 'Venus'},
              { label: 'Vernon' , value: 'Vernon'},
              { label: 'Vero Beach' , value: 'Vero Beach'},
              { label: 'Wabasso' , value: 'Wabasso'},
              { label: 'Wacissa' , value: 'Wacissa'},
              { label: 'Waldo' , value: 'Waldo'},
              { label: 'Wauchula' , value: 'Wauchula'},
              { label: 'Wausau' , value: 'Wausau'},
              { label: 'Waverly' , value: 'Waverly'},
              { label: 'Webster' , value: 'Webster'},
              { label: 'Weirsdale' , value: 'Weirsdale'},
              { label: 'Welaka' , value: 'Welaka'},
              { label: 'Wellborn' , value: 'Wellborn'},
              { label: 'Wellington' , value: 'Wellington'},
              { label: 'Wesley Chapel' , value: 'Wesley Chapel'},
              { label: 'West Palm Beach' , value: 'West Palm Beach'},
              { label: 'Westville' , value: 'Westville'},
              { label: 'Wewahitchka' , value: 'Wewahitchka'},
              { label: 'White Springs' , value: 'White Springs'},
              { label: 'Wildwood' , value: 'Wildwood'},
              { label: 'Williston' , value: 'Williston'},
              { label: 'Wimauma' , value: 'Wimauma'},
              { label: 'Windermere' , value: 'Windermere'},
              { label: 'Winter Beach' , value: 'Winter Beach'},
              { label: 'Winter Garden' , value: 'Winter Garden'},
              { label: 'Winter Haven' , value: 'Winter Haven'},
              { label: 'Winter Park' , value: 'Winter Park'},
              { label: 'Winter Springs' , value: 'Winter Springs'},
              { label: 'Woodville' , value: 'Woodville'},
              { label: 'Worthington Springs' , value: 'Worthington Springs'},
              { label: 'Yalaha' , value: 'Yalaha'},
              { label: 'Yankeetown' , value: 'Yankeetown'},
              { label: 'Youngstown' , value: 'Youngstown'},
              { label: 'Yulee' , value: 'Yulee'},
              { label: 'Zellwood' , value: 'Zellwood'},
              { label: 'Zephyrhills' , value: 'Zephyrhills'},
              { label: 'Zolfo Springs' , value: 'Zolfo Springs'}
          ],
          mapping: 'city'
        }
       ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Event Location:',
            options: [
              { label: 'Business' , value: 'Business'},
              { label: 'Residential', value: 'Residential' }
            ],
            mapping: 'bustype'
          }
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: '*Primary Contact Phone #:',
           mapping: 'telnumber'
         }
       ]
     },
     {
        fields: [
        {
          type: 'text',
          size: 'Medium',
          label: '*Cell Contact Phone #:',
          mapping: 'cellnumber'
        }
      ]
     },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: '*Your Email Address:',
            mapping: 'email'
          },
         ]
        },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: '*Date of Event:',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: '*Number in Party:',
            options: [
              { label: '50' , value: '50'},
              { label: '55' , value: '55'},
              { label: '60' , value: '60'},
              { label: '65' , value: '65'},
              { label: '70' , value: '70'},
              { label: '75' , value: '75'},
              { label: '80' , value: '80'},
              { label: '85' , value: '85'},
              { label: '90' , value: '90'},
              { label: '95' , value: '95'},
              { label: '100' , value: '100'},
              { label: '110' , value: '110'},
              { label: '120' , value: '120'},
              { label: '130' , value: '130'},
              { label: '140' , value: '140'},
              { label: '150' , value: '150'},
              { label: '160' , value: '160'},
              { label: '170' , value: '170'},
              { label: '180' , value: '180'},
              { label: '190' , value: '190'},
              { label: '200' , value: '200'},
              { label: '225' , value: '225'},
              { label: '250' , value: '250'},
              { label: '275' , value: '275'},
              { label: '300' , value: '300'},
              { label: '325' , value: '325'},
              { label: '350' , value: '350'},
              { label: '375' , value: '375'},
              { label: '400' , value: '400'},
              { label: '425' , value: '425'},
              { label: '450' , value: '450'},
              { label: '475' , value: '475'},
              { label: '500' , value: '500'},
              { label: '525' , value: '525'},
              { label: '550' , value: '550'},
              { label: '575' , value: '575'},
              { label: '600' , value: '600'},
              { label: '625' , value: '625'},
              { label: '650' , value: '650'},
              { label: '675' , value: '675'},
              { label: '700' , value: '700'},
              { label: '725' , value: '725'},
              { label: '750' , value: '750'},
              { label: '775' , value: '775'},
              { label: '800' , value: '800'},
              { label: '1000' , value: '1000'},
              { label: '2000' , value: '2000'},
              { label: '3000' , value: '3000'},
              { label: '4000' , value: '4000'},
              { label: '5000' , value: '5000'},
              { label: '6000' , value: '6000'},
              { label: '7000' , value: '7000'},
              { label: '8000' , value: '8000'},
              { label: '9000' , value: '9000'}
            ],
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: '*Serving Time:',
            options: [
              { label: '6:00AM'  , value: '06:00:00'},
              { label: '6:30AM'  , value: '06:30:00'}, 
              { label: '7:00AM'  , value: '07:00:00'},
              { label: '7:30AM'  , value: '07:30:00'},
              { label: '8:00AM'  , value: '08:00:00'},
              { label: '8:30AM'  , value: '08:30:00'},
              { label: '9:00AM'  , value: '09:00:00'},
              { label: '9:30AM'  , value: '09:30:00'},
              { label: '10:00AM' , value: '10:00:00'},
              { label: '10:30AM' , value: '10:30:00'},
              { label: '11:00AM' , value: '11:00:00'},
              { label: '11:30AM' , value: '11:30:00'},
              { label: '12:00PM' , value: '12:00:00'},
              { label: '12:30PM' , value: '12:30:00'},
              { label: '1:00PM'  , value: '13:00:00'},
              { label: '1:30PM'  , value: '13:30:00'},
              { label: '2:00PM'  , value: '14:00:00'},
              { label: '2:30PM'  , value: '14:30:00'},
              { label: '3:00PM'  , value: '15:00:00'},
              { label: '3:30PM'  , value: '15:30:00'},
              { label: '4:00PM'  , value: '16:00:00'},
              { label: '4:30PM'  , value: '16:30:00'},
              { label: '5:00PM'  , value: '17:00:00'},
              { label: '5:30PM'  , value: '17:30:00'},
              { label: '6:00PM'  , value: '18:00:00'},
              { label: '6:30PM'  , value: '18:30:00'},
              { label: '7:00PM'  , value: '19:00:00'},
              { label: '7:30PM'  , value: '19:30:00'},
              { label: '8:00PM'  , value: '20:00:00'},
              { label: '8:30PM'  , value: '20:30:00'},
              { label: '9:00PM'  , value: '21:00:00'},
              { label: '9:30PM'  , value: '21:30:00'},
              { label: '10:00PM' , value: '22:00:00'}
            ],
            mapping: 'starttime',
          }
        ]
      },      
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Please Enter Comments or Instructions below:',
            mapping: 'notes',
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Florida Catering Co BBQ Catering Request Form',
    formId: '175',
    clientKey: '479CB824-F781-4614-9FDC-F22C724E62EB',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissiontext: 'Thank you! Your message has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/floridacateringco2/form_structure.js